import Layout from '@/pages/frame';

import editPassword from '@/pages/user/forgetPwd';

// import upload from '@/pages/resourseCenter/upload';
// import myResourse from '@/pages/resourseCenter/myResourse';
export default {
    path: '/user',
    component: Layout,
    redirect: to => { return 'index' },
    children: [
        // { path: 'index', component:  index    },//资源中心首页
     
        { path: 'editPassword',component:  editPassword },//用户中心
     

    ]
}



// WEBPACK FOOTER //
// ./src/routes/modules/user.js